import * as R from 'ramda';


export default function DeleteSchematicsDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  bcpDataService,
  ssDialogService,
  confirmDialog
) {
  const vm = this;
  
  vm.deleteIsSelected = false;
  vm.hasData = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleDelete = _handleDelete;
  vm.handleSelectAll = _handleSelectAll;
  vm.handleSelectOne = _handleSelectOne;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.deleteSchematicsDialog);
  }

  function _handleSelectAll() {
    R.forEach((schematic) => {
      schematic.isSelected = vm.selectAll;
      vm.deleteIsSelected = vm.selectAll;
    }, vm.mainOfficeSchematics);

    R.forEach((schematic) => {
      schematic.isSelected = vm.selectAll;
      vm.deleteIsSelected = vm.selectAll;
    }, vm.branchSchematics);

    R.forEach((schematic) => {
      schematic.isSelected = vm.selectAll;
      vm.deleteIsSelected = vm.selectAll;
    }, vm.disasterRecoverySchematics);
  }

  function _handleSelectOne() {
    let itemDeleteIsSelected = false;
    
    R.forEach((schematic) => {
      if (schematic.isSelected) {
        itemDeleteIsSelected = true;
      }
    }, vm.mainOfficeSchematics);
    
    R.forEach((schematic) => {
      if (schematic.isSelected) {
        itemDeleteIsSelected = true;
      }
    }, vm.branchSchematics);
    
    R.forEach((schematic) => {
      if (schematic.isSelected) {
        itemDeleteIsSelected = true;
      }
    }, vm.disasterRecoverySchematics);

    vm.deleteIsSelected = itemDeleteIsSelected
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.confirmDeleteSchematicsDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Schematics?',
        message: `Are you sure you want to delete the selected Schematics?`,
        handleYesClick() {
          _handleConfirmDelete();
        },
        handleNoClick: _handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteSchematicsDialog);
  }

  function _handleConfirmDelete(schematic) {
    const _ids = [];

    R.forEach((schematic) => {
      if (schematic.isSelected) {
        _ids.push(schematic.assessmentSchematicId);
      }
    }, vm.mainOfficeSchematics);

    R.forEach((schematic) => {
      if (schematic.isSelected) {
        _ids.push(schematic.assessmentSchematicId);
      }
    }, vm.branchSchematics);

    R.forEach((schematic) => {
      if (schematic.isSelected) {
        _ids.push(schematic.assessmentSchematicId);
      }
    }, vm.disasterRecoverySchematics);
  
    const idList = {};
    idList.ids = _ids;

    return bcpDataService.deleteSchematics(idList).then(() => {
      alerts.success('The selected Schematic(s) have been deleted successfully.');
      $rootScope.$broadcast('setDocumentRegenerateFlag');
      $rootScope.$broadcast('refreshBCPSchematics');
      _closeDeleteDialog();
      _handleCloseDialog();
    })
    .catch(() => {
      alerts.error('An error occurred deleting the selected Schematic(s).');
    });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteSchematicsDialog);
  }
}

DeleteSchematicsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'bcpDataService',
  'ssDialogService',
  'confirmDialog',
];
